"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingContextLoadedEvent = exports.Name = void 0;
const Name = exports.Name = 'shopping-context-loaded';
const ShoppingContextLoadedEvent = exports.ShoppingContextLoadedEvent = Name;
